export default __webpack_public_path__ + "static/media/proj12.4d233f91.png";